import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useShopHeroSectionStyles } from "./ShopHeroSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useCommerceData } from "../../../../hooks/useCommerceData";
import { commerceRepository } from "../../../../api";

interface ShopHeroSectionProps {
    category?: string;
}

const ShopHeroSection = (props: ShopHeroSectionProps) => {
    const { classes } = useShopHeroSectionStyles();
    const { t } = useI18n();
    const { data: collection } = useCommerceData(
        () => (props.category ? commerceRepository.getCollectionByHandle(props.category) : Promise.resolve(null)),
        [props.category]
    );

    const title = collection?.title ?? t("shopPage.hero.title");
    const description = collection?.description ?? t("shopPage.hero.description");

    return (
        <Box className={classes.root}>
            <Box className={classes.container}>
                <Box className={classes.breadcrumb}>
                    <Typography component={RouterLink} to="/" className={classes.breadcrumbLink}>
                        {t("nav.shop")}
                    </Typography>
                    {collection && (
                        <>
                            <span>/</span>
                            <Typography>{collection.title}</Typography>
                        </>
                    )}
                </Box>
                <Typography variant="h1">{title}</Typography>
                <Typography variant="body1" className={classes.description}>{description}</Typography>
            </Box>
        </Box>
    );
};

export default ShopHeroSection;
